<template>
  <v-dialog
      v-model="showModal"
      width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="red lighten-2"
          dark
          v-on="on"
        >
          Click Me
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Informacion de cache
        </v-card-title>

        <v-card-text>
          {{information}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="$emit('close')"
          >
            Salir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>

import { cachiosInstance } from '../../axios';

export default {
  name: 'cache-stats',
  props: ['show'],
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    information() {
      return cachiosInstance.cache.getStats();
    },
  },
  watch: {
    show: {
      handler(newVal) {
        this.showModal = newVal;
      },
    },
  },
};
</script>